import React from "react";

class TextInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      value: props.value ? props.value : "",
      fresh: true,
      reset: () => this.reset()
    };
  }

  reset() {
    this.setState({
      isValid: false,
      value: this.props.value ? this.props.value : "",
      fresh: true
    });
  }

  onChange(e) {
    const value = e.target.value;
    const { minLength, maxLength, validation } = this.props;

    let isValid = true;

    if (minLength && value.trim().length < minLength) isValid = false;
    if (maxLength && value.length > maxLength) isValid = false;

    if (validation === "email") {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) isValid = false;
    }

    this.setState({ value: value, isValid: isValid, fresh: false });
  }

  render() {
    const { placeholder, maxLength, noBorder, area, noSpellcheck } = this.props;
    const { value } = this.state;

    const isValid = this.state.fresh ? true : this.state.isValid;

    return (
      <div className="TextInputWrap" style={{ marginTop: "16px" }}>
        <small>
          {placeholder}
          {isValid ? null : (
            <p style={{ float: "right", color: "var(--color-bad)" }}>
              Erforderlich
            </p>
          )}
        </small>
        {area ? (
          <textarea
            id={isValid ? "" : "invalid"}
            value={value}
            onChange={e => this.onChange(e)}
            spellCheck={noSpellcheck === true}
            style={noBorder ? {} : { borderStyle: "solid" }}
          />
        ) : (
          <input
            id={isValid ? "" : "invalid"}
            type="text"
            value={value}
            onChange={e => this.onChange(e)}
            style={noBorder ? {} : { borderStyle: "solid" }}
          />
        )}
        {maxLength ? (
          <small
            style={{
              float: "right",
              color: isValid ? "" : "var(--color-bad)"
            }}
          >{`${value.length}/${maxLength}`}</small>
        ) : null}
      </div>
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput.js